
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic09Static as ObiHydraulic09StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-09-static.js';
 
 
 

 
 export const ObiHydraulic09Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-09-static',
   elementClass: ObiHydraulic09StaticElement,
   events: {
     
   }
  });
 
 